export function calcularMetrosQuadrados(comprimentoRaw: any, larguraRaw: any): number 
{
  let comprimento = parseFloat(String(comprimentoRaw).replace(',', '.'));
  let largura = parseFloat(String(larguraRaw).replace(',', '.'));

  if (isNaN(comprimento)) comprimento = 0;
  if (isNaN(largura)) largura = 0;

  return comprimento * largura;
}